import React from 'react';
import ReportLayout, { StatusChip, BoolChip, fmtDate, fmtDateTime } from './ReportLayout';

const COLUMNS = [
  { key: 'pass_id', label: 'Pass ID', sortable: false },
  { key: 'item_name', label: 'Item Name' },
  { key: 'quantity', label: 'Qty', sortable: false },
  { key: 'item_type', label: 'Type', sortable: false, render: v => <StatusChip value={v} /> },
  { key: 'party_name', label: 'Party Name' },
  { key: 'status', label: 'Status', render: v => <StatusChip value={v} /> },
  { key: 'expected_return_date', label: 'Expected Return', render: v => fmtDate(v) },
  { key: 'returned_at', label: 'Returned At', sortable: false, render: v => fmtDateTime(v) },
  { key: 'is_overdue', label: 'Overdue', sortable: false, render: v => <BoolChip value={v} /> },
  { key: 'created_by_name', label: 'Created By', sortable: false },
  { key: 'created_at', label: 'Created At', render: v => fmtDateTime(v) },
];

const FILTERS = [
  {
    type: 'select',
    name: 'status',
    label: 'Status',
    defaultValue: 'all',
    options: [
      { value: 'pending', label: 'Pending' },
      { value: 'returned', label: 'Returned' },
      { value: 'completed', label: 'Completed' },
    ],
  },
  {
    type: 'select',
    name: 'item_type',
    label: 'Item Type',
    defaultValue: 'all',
    options: [
      { value: 'returnable', label: 'Returnable' },
      { value: 'non_returnable', label: 'Non-Returnable' },
    ],
  },
];

export default function ItemReport() {
  return (
    <ReportLayout
      title="Items Report"
      description="All item passes including returnable and non-returnable goods"
      endpoint="/reports/items"
      columns={COLUMNS}
      filters={FILTERS}
      defaultSort="created_at"
      defaultOrder="desc"
      exportFilename="items-report"
    />
  );
}
